import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

/**
 * @param {String} tripId
 * @param {Boolean} tripSummary
 */
function changeTripButtonClicked({ tripId, tripSummary }) {
    const property = { trip_id: tripId };

    SnowplowService.fireStructuredEventWithBatchId({
        action: 'click',
        category: tripSummary
            ? 'react_tripsummary'
            : 'react_search',
        label: 'change_trip',
        property,
    });

    amplitude.track('change_trip clicked', property);
}

export {
    changeTripButtonClicked,
};

export default {
    changeTripButtonClicked,
};
